module.exports = __webpack_public_path__ + "img/monero.d769acfd.png";